import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateOrgHttpModel, CreateOrgModel, OrgHttpModel, OrgUIModel } from '../models';

@Injectable({ providedIn: 'root' })
export class OrgHttpService {
  constructor(private readonly httpClient: HttpClient) {}

  private readonly baseUrl = `${environment.url.company_api}/companies`;

  getOrgs(): Observable<OrgHttpModel[]> {
    return this.httpClient.get<{ data: OrgHttpModel[] }>(this.baseUrl).pipe(map(({ data }) => data));
  }

  createOrg(createOrg: CreateOrgModel): Observable<OrgHttpModel> {
    const createOrgHttpModel: CreateOrgHttpModel = {
      ...createOrg,
      email_join: false,
    };
    return this.httpClient.post<{ data: OrgHttpModel }>(this.baseUrl, createOrgHttpModel).pipe(map(({ data }) => data));
  }

  updateOrg(orgId: OrgUIModel['id'], org: Partial<OrgUIModel>): Observable<OrgHttpModel> {
    return this.httpClient.put<{ data: OrgHttpModel }>(`${this.baseUrl}/${orgId}`, org).pipe(map(({ data }) => data));
  }

  deleteOrg(orgId: OrgUIModel['id']): Observable<void> {
    return this.httpClient.delete<unknown>(`${this.baseUrl}/${orgId}`).pipe(map(() => undefined));
  }

  isOrgSlugAvailable(slug: string): Observable<boolean> {
    return this.httpClient
      .get<{ exists: boolean }>(`${this.baseUrl}/slug/${slug}/exists`)
      .pipe(map(({ exists }) => !exists));
  }

  isOrgInviteCodeValid(code: string): Observable<boolean> {
    return this.httpClient
      .post<{ valid: boolean }>(`${environment.url.company_api}/valid/code`, { code })
      .pipe(map(({ valid }) => valid));
  }

  getAllJoinableOrgs(email: string): Observable<OrgHttpModel[]> {
    return this.httpClient
      .get<{ data: OrgHttpModel[] }>(`${this.baseUrl}/available`, { params: { email } })
      .pipe(map(({ data }) => data));
  }
}
